export default function InfoMessage({children}) {
    return (
        <div className="room__row" data-container="loaded">
            <p>{children}</p>
        </div>
    );
}